<template>
  <div class="gbb-wrapper">


    <div class="gbb-card">

      <p class="gbb-hint">{{ $t('helpBookedBet') }}</p>


      <div class="gbb-field-group" :class="{ 'has-error': errors.length, 'has-success': success.length }">
        <div class="gbb-row">
          <div class="gbb-input-wrap">
            <span class="gbb-input-icon">
          <svg width="28px" height="28px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.75 6L7.5 5.25H16.5L17.25 6V19.3162L12 16.2051L6.75 19.3162V6ZM8.25 6.75V16.6838L12 14.4615L15.75 16.6838V6.75H8.25Z" fill="currentColor"/>
          </svg>
            </span>
            <input
              class="gbb-input"
              type="text"
              v-model="betCode"
              :placeholder="$t('betCode')"
              autocomplete="off"
              @input="removeAlerts"
              @keyup.enter="getBookedBet"
            />
            <button v-if="betCode" class="gbb-clear" @click="betCode = ''; removeAlerts()" type="button">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <button class="gbb-btn" @click="getBookedBet" :disabled="loading">
            <span v-if="loading" class="gbb-spinner"></span>
            <span v-else>{{ $t('load') }}</span>
          </button>
        </div>

        <transition name="gbb-msg">
          <p v-if="errors.length" class="gbb-message gbb-error">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ errors[0] }}
          </p>
          <p v-else-if="success.length" class="gbb-message gbb-success">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>
            {{ success[0] }}
          </p>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {isMobileOnly} from "mobile-device-detect";

export default {
  name: 'GetBookedBet',
  data: () => ({
    betCode: '',
    errors: [],
    success: [],
    loading: false,
  }),
  computed: {
    ...mapGetters({
      'getLanguage': 'settings/getLanguage',
    }),
  },
  mounted() {
    this.checkUrlForBookingCode();
  },
  methods: {
    ...mapActions({
      'setLoadingCart': 'cart/setLoadingCart',
      'fetchBookedBet': 'cart/fetchBookedBet',
    }),

    // Funzione che controlla i parametri URL al caricamento
// Funzione che controlla i parametri URL al caricamento
    checkUrlForBookingCode() {
      let codeParam = null;

      if (typeof window !== 'undefined') {
        try {
          // 1. TENTA DI LEGGERE L'URL DELLA PAGINA PRINCIPALE (BARRA DEL BROWSER)
          // Nota: Funziona se l'iframe e il sito padre sono sullo stesso dominio.
          if (window.top && window.top.location) {
            const topUrlParams = new URLSearchParams(window.top.location.search);
            codeParam = topUrlParams.get('bookingCode');
          }
        } catch (e) {
          console.warn("Impossibile accedere all'URL principale (Cross-Origin). Leggo l'URL dell'iframe.");
        }

        // 2. FALLBACK: Cerca nell'URL dell'iframe se non trovato sopra
        if (!codeParam) {
          const urlParams = new URLSearchParams(window.location.search);
          codeParam = urlParams.get('bookingCode');
        }
      }

      // 3. FALLBACK: se usi vue-router e i parametri sono nell'hash
      if (!codeParam && this.$route && this.$route.query) {
        codeParam = this.$route.query.bookingCode;
      }

      // Se il codice esiste, lo inserisce e fa partire la chiamata
      if (codeParam) {
        this.betCode = codeParam;
        this.getBookedBet();
        if (isMobileOnly) {
          this.$root.$emit('open_sidebar_right', true);
        }
      }
    },

    async getBookedBet() {
      if (!this.betCode.trim()) {
        this.success = [];
        this.errors = [this.$t('codeRequired') || 'Codice richiesto'];
        return;
      }
      this.loading = true;
      await this.setLoadingCart({ status: true });
      const bet = await this.fetchBookedBet({ code: this.betCode });

      if (!bet.result) {
        this.success = [];
        this.errors = [this.$t('betCodeNotValid') || 'Codice non valido'];
      } else {
        this.errors = [];
        this.success = [this.$t('betCodeSuccess') || 'Caricamento completato'];
        this.betCode = ''; // Svuota l'input in caso di successo (opzionale)
      }

      this.loading = false;
      await this.setLoadingCart({ status: false });
    },

    removeAlerts() {
      this.errors = [];
      this.success = [];
    },
  },
};
</script>

<style scoped>
.gbb-wrapper {
  padding: 14px;
  border-radius: 12px;
  background: var(--sidebar);
}

.gbb-header {
  margin-bottom: 10px;
}

.gbb-title {
  font-size: var(--font-size-xl);
  font-weight: 700;
  text-transform: uppercase;
  color: var(--text-op-50-platform);
}

.gbb-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.gbb-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.gbb-help {
  font-size: var(--font-size-2xl);
  color: var(--text-op-50-platform);
  text-align: center;
  margin: 0;
  line-height: 1.5;
}

/* Field */
.gbb-field-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.gbb-label {
  font-size: var(--font-size-xl);
  font-weight: 600;
  color: var(--text-op-50-platform);
  text-transform: uppercase;
}

.gbb-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.gbb-input-icon {
  position: absolute;
  left: 6px;
  color: var(--text-op-50-platform);
  display: flex;
  align-items: center;
  pointer-events: none;
}

.gbb-input {
  width: 100%;
  height: 42px;
  background: var(--bg-cell);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 0 36px 0 36px;
  font-size: var(--font-size-3xl);
  font-weight: 600;
  color: var(--text-platform);
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.gbb-input::placeholder {
  color: var(--text-op-50-platform);
  font-weight: 400;
}

.gbb-input:focus {
  border-color: var(--color-primary-light);
  box-shadow: 0 0 0 3px rgba(0, 96, 57, 0.15);
}

.has-error .gbb-input {
  border-color: #e53935;
  box-shadow: 0 0 0 3px rgba(229, 57, 53, 0.12);
}

.has-success .gbb-input {
  border-color: #43a047;
  box-shadow: 0 0 0 3px rgba(67, 160, 71, 0.12);
}

.gbb-clear {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-op-50-platform);
  padding: 4px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  transition: color 0.15s;
}

.gbb-clear:hover { color: var(--text-platform); }

.gbb-hint {
  font-size: var(--font-size-3xl);
  font-weight: 600;
  color: var(--text-platform);
  text-transform: uppercase;
  margin-bottom: 6px!important;
}

/* Messages */
.gbb-message {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: var(--font-size-2xl);
  font-weight: 600;
  margin: 0;
}

.gbb-error { color: #ef5350; }
.gbb-success { color: #66bb6a; }

.gbb-msg-enter-active, .gbb-msg-leave-active { transition: opacity 0.2s, transform 0.2s; }
.gbb-msg-enter, .gbb-msg-leave-to { opacity: 0; transform: translateY(-4px); }

/* Button */
.gbb-btn {
  flex-shrink: 0;
  height: 42px;
  padding: 0 16px;
  background: var(--btn-background);
  color: var(--btn-text);
  border: none;
  border-radius: 8px;
  font-size: var(--font-size-3xl);
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s, transform 0.1s;
  touch-action: manipulation;
}

.gbb-btn:active { transform: scale(0.98); opacity: 0.85; }
.gbb-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* Spinner */
.gbb-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(0,0,0,0.2);
  border-top-color: #000;
  border-radius: 50%;
  animation: gbb-spin 0.7s linear infinite;
}

@keyframes gbb-spin { to { transform: rotate(360deg); } }
</style>
